import React from "react";

import styles from "../styles/TechInfo.module.scss";

interface ITechInfo {
  title?: string;
  email?: string;
  tel?: string;
}

const defaultTitle = "SC Информационная система «Ситуационная панель»";
const defaultEmail = "";
const defaultTel = "";

const TechInfo: React.FC<ITechInfo> = ({
  title = defaultTitle,
  email = defaultEmail,
  tel = defaultTel,
}) => {
  const hrefTel = tel.replace(/\D/g, "");
  return email && tel ? (
    <div className={styles.content}>
      <ul className={styles["content__list"]}>
        <li className={styles["content__item"]}>{title}</li>
        <li className={styles["content__item"]}>
          <a href={`mailto:${email}`}>{email}</a>
        </li>
        <li className={styles["content__item"]}>
          <a href={`tel:+7${hrefTel}`}>{tel}</a>
        </li>
      </ul>
    </div>
  ) : (
    <div className={styles.content}>{title}</div>
  );
};

export default TechInfo;
